import { TFunction } from '@/lib/i18n/i18n'

export const getStandardValidationMessage = (t: TFunction) => ({
	required: t('form-validation.required'),
	minValue: (value: number) => t('form-validation.min-value', { value }),
	maxValue: (value: number) => t('form-validation.max-value', { value }),
	minLength: (value: number) => t('form-validation.min-length', { value }),
	maxLength: (value: number) => t('form-validation.max-length', { value }),
	invalidEmail: t('form-validation.credit-card.invalid-email'),
	strictLength: (count: number) => t('form-validation.strict-quantity-of-characters', { count }),
	alphanumeric: t('form-validation.alphanumeric'),
	alphanumericWithSpaces: t('form-validation.alphanumeric-with-spaces'),
	numeric: t('form-validation.numeric'),
	lastTwoDigits: t('form-validation.last-two-digits'),
	firstThreeLetters: t('form-validation.first-three-letters'),
	firstThreeLettersAndLastTwoDigits: t('form-validation.first-three-letters-and-last-two-digits'),
})

export const getValidationMessageForName = (t: TFunction) => t('form-validation.name')
export const getValidationMessageForPassportNumber = (t: TFunction) =>
	t('form-validation.document-number', { range: '6-9' })
export const getValidationMessageForNationalIdNumber = (t: TFunction) =>
	t('form-validation.document-number', { range: '5-16' })
export const getValidationMessageForLastName = (t: TFunction) => t('form-validation.last-name')
export const getValidationMessageForExpiresDate = (t: TFunction) => t('passport-form-validation.date-is-expires')
export const getValidationMessageForInvalidPhoneNumber = (t: TFunction) => t('form-validation.invalid-phone-number')
